import { DiagramModel } from "@projectstorm/react-diagrams";
import { selectedAutomationNode } from "../../Template/NewTemplateSignals";
import { AdaptiveNode } from "../Nodes/NodeFactory";

export const CustomDiagramModel = () => {
  const newModel = new DiagramModel();

  const TriggerNodeConstructor = AdaptiveNode("TriggerNode");
  const TriggerNode = new TriggerNodeConstructor({
    position: { x: 250, y: 125 },
    nodeProperties: { Name: "New Trigger Node", TriggerType: "Manual", Type: "Trigger" },
  });

  const TerminateNodeConstructor = AdaptiveNode("TerminateNode");
  const TerminateNode = new TerminateNodeConstructor({ position: { x: 750, y: 300 } });

  newModel.registerListener({
    selectionChanged: (event) => {
      const selectedNodes = event.isSelected;
      if (selectedNodes.length > 0) {
        const selectedNodeId = selectedNodes[0].getOptions().id;
        selectedAutomationNode.value = selectedNodeId;
      } else {
        selectedAutomationNode.value = null;
      }
    },
  });

  newModel.addAll(TriggerNode, TerminateNode);

  return {
    id: new Date().getTime(),
    name: "New Automation",
    model: newModel,
  };
};
